module.exports = __webpack_public_path__ + "img/Dantam Makeover 13.4970a28e.jpg";